import { ResizeObserver as Polyfill } from '@juggle/resize-observer';
const ResizeObserver = window.ResizeObserver || Polyfill;

// WATCH WIDTH

// Uses resizeObserver to watch for width changes in an element.
// and add/remove classes based on width min/max values.

// data-watch-width="0,499,small|500,999,medium|1000,*,large"
// pipe-delimited sets of three values - min-width, max-width, classname.
// use * in the min or max values for no limit, eg '*,999,classname' = from zero to 999 px wide.
// sets can overlap, allowing for combinations of classnames.

class Watcher {

    constructor(el) {
        this.el = el;
        let getData = el.dataset.widthWatcher;
        this.data = [];
        this.width = 0;
        this.updateRequested = false;
        this.updateTimeout = null;
        this.updateTimeoutDelay = 0;
        if(getData != "") {
            getData.split('|').forEach(d => {
                let split = d.split(',');
                if(split.length == 3) this.data.push(new WatcherDataSet(split));
            });
            // add resize observer
            this.ro = new ResizeObserver(entries => {
                for (let entry of entries) {
                    const cr = entry.contentRect;
                    if(cr.width != this.width) {
                        this.width = cr.width;
                        if(!this.updateRequested) {
                            this.updateRequested = true;
                            this.updateTimeout = setTimeout(() => {
                                this.update();
                                this.updateRequested = false;
                                this.updateTimeout = null;
                            }, this.updateTimeoutDelay);
                        }
                    }
                }
            });
            this.ro.observe(this.el); // Watch dimension changes wrapping element
        }
    }

    update() {
        window.requestAnimationFrame(() => {
            this.data.forEach(d => {
                let toggleValue = false;
                if(d.checkMin && d.checkMax) {
                    toggleValue = this.width >= d.min && this.width <= d.max;
                } else if(d.checkMin) {
                    toggleValue = this.width >= d.min;
                } else if(d.checkMax) {
                    toggleValue = this.width <= d.max;
                }
                this.el.classList.toggle(d.classString, toggleValue);
            });
            this.updateTimeoutDelay = 50;
            window.requestAnimationFrame(() => {
                this.el.classList.add('width-watched');
            });
        });
    }
}

class WatcherDataSet {

    constructor(d) {
        this.min = 0;
        this.max = 0;
        this.checkMin = false; 
        this.checkMax = false;
        this.classString = d[2];
        let parseMin = parseInt(d[0]);
        let parseMax = parseInt(d[1]);
        if(parseMin > 0) {
            this.min = parseMin;
            this.checkMin = true;
        }
        if(parseMax > 0) {
            this.max = parseMax;
            this.checkMax = true;
        }
    }
}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new Watcher(node);
        }
    });
}